var _excluded = ["onCancel", "children", "className", "description"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import styled from 'styled-components';
import { Close } from "../../../icons/index.js";
import Button from "../../basic/Button/Button.js";
import Layout from "../../basic/Layout/Layout.js";
import BodyText from "../../type/BodyText.js";
import Heading from "../../type/Heading.js";
export var DRAWER_HEADER_CLASSNAME = 'drawer__header';
export var DRAWER_HEADER_ID = 'drawer__header';
var StyledDrawerHeader = styled.header.withConfig({
  componentId: "CL__sc-1lx3aiw-0"
})(["background-color:var(--modal-bkg-color);padding:var(--spacing-4) var(--spacing-1) var(--spacing-2);position:sticky;top:0;transition:border-color var(--hover-transition);border-bottom:1px solid transparent;.is-scrollable:not(.is-at-top) &{border-bottom:1px solid var(--border-color-dim);}"]);
var DrawerHeader = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var {
      onCancel,
      children,
      className,
      description
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledDrawerHeader, _extends({
    className: "".concat(className ? "".concat(DRAWER_HEADER_CLASSNAME, " ").concat(className) : DRAWER_HEADER_CLASSNAME),
    ref: ref
  }, props), /*#__PURE__*/React.createElement(Layout, {
    align: "justify",
    id: DRAWER_HEADER_ID,
    valign: "top"
  }, /*#__PURE__*/React.createElement(Layout, {
    vertical: true
  }, /*#__PURE__*/React.createElement(Heading, {
    as: "h2",
    size: "x-small"
  }, children), description && /*#__PURE__*/React.createElement(BodyText, null, description)), onCancel && /*#__PURE__*/React.createElement(Button, {
    variant: "plain",
    size: "large",
    icon: Close,
    "aria-label": "Close Drawer",
    onClick: onCancel
  })));
});
export default DrawerHeader;